import { motion } from "framer-motion";
import { Heart, Users, Sparkles } from "lucide-react";

const pillars = [
  {
    icon: Sparkles,
    title: "Transformation",
    text: "A place where lives are changed by the power and presence of God — where the broken find healing and the lost find home.",
  },
  {
    icon: Users,
    title: "Community",
    text: "Rooted in Clayton County, we are building a family that loves God, loves people, and serves our city with excellence.",
  },
  {
    icon: Heart,
    title: "Purpose",
    text: "Every person carries a calling. The Change Center is where you discover, develop, and deploy your God-given gifts.",
  },
];

export const Mission = () => {
  return (
    <section id="vision" data-testid="vision-section" className="relative py-24 sm:py-32 px-6 sm:px-10">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-16"
        >
          <p className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Our Heart</p>
          <h2 className="font-display text-4xl sm:text-6xl font-semibold leading-tight text-[#F9F6F0]">
            We believe Atlanta is ready for{" "}
            <span className="gold-text italic">a change</span>.
          </h2>
          <p className="text-[#A19CA8] text-lg leading-relaxed mt-7">
            The Change Center Church is more than a building — it's a movement of restoration,
            worship, and purpose coming to Clayton County. Before we open our doors, we're
            gathering the people who will help shape this house. That could be you.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid={`pillar-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="group bg-[#130A1F]/60 backdrop-blur-xl border border-[#D4AF37]/20 p-8 hover:border-[#D4AF37]/60 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="h-14 w-14 flex items-center justify-center border border-[#D4AF37]/40 mb-6 group-hover:bg-[#D4AF37]/10 transition-colors">
                <p.icon className="h-6 w-6 text-[#D4AF37]" />
              </div>
              <h3 className="font-display text-2xl text-[#D4AF37] mb-3">{p.title}</h3>
              <p className="text-[#A19CA8] leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
